import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .input-box {
    display: grid;
    /* grid-template-rows: repeat(3, max-content); */
    width: 100%;
    margin-bottom: 10px;
    
    h3 {
      /* font-weight: 700; */
      font-size: 18px;
      line-height: 24.52px;
      margin-bottom: 8px;
      color: ${({ theme }) => theme.mainTheme.color.gray50};
    }

    .MuiAutocomplete-root {
      display: grid;
    }
  }

  .recipient-list-count {
    border-radius: 8px;
    padding: 12px;
    font-size: 14px;
    color: ${({ theme }) => theme.mainTheme.color.gray40};
    background-color: #f7fafc;

    .recipient-list-count__number {
      font-weight: 700;
      color: ${({ theme }) => theme.mainTheme.color.gray50};
    }
  }

  .controls {
    display: flex;
    justify-content: space-between;
    gap: 8px;

    button {
      flex-grow: 1;
    }
  }
`;
